<template>
  <div class="terms-of-service-container">
    <app-header />
    <div class="area-article">
      <h1 class="area-title">
        {{ title }}
      </h1>
      <div class="area-content v1-content" v-html="$md.render(body)" />
    </div>
    <app-footer />
  </div>
</template>

<script>
/* eslint-disable */
import AppHeader from '../organisms/AppHeader'
import AppFooter from '../organisms/AppFooter'

export default {
  components: {
    AppHeader,
    AppFooter
  },
  computed: {
    title() {
      return '利用規約'
    },
    body() {
      return `
本規約は、株式会社ALIS（以下「当社」といいます）が運営するサイト「ALIS」および「ALIS」を通じて提供されるサービス（以下、併せて「本サービス」といいます）についての利用条件を定めるものです。なお、本規約は各サービスにおけるガイドライン、規程、注意事項等の諸規程と共に適用され、当該ガイドライン等の諸規程は、本規約の一部を構成します。利用者は、本規約に同意いただくことで、本サービスを利用することができます。各サービスのガイドライン等の諸規程は、「ALIS」内の各サービス内において別途掲載いたします。

## 第1条（定義）

本規約において、使用する用語の定義は、以下の各号に定めるとおりとします。

(1)    「利用者」：会員および本サービスを利用する全ての者
(2)    「会員」：会員サービスの提供を希望し、本規約に同意の上、会員登録をした者
(3)    「登録情報」：会員サービスの提供を受ける目的で、会員登録希望者または会員が当社に提供する一切の情報
(4)    「認証情報」：登録情報のうち、IDおよびパスワードその他当社が会員からの接続を認証するために必要な情報
(5)    「退会」：会員が、本規約および当社が定める方法により、登録情報を抹消し、会員サービスの提供を受けるのを終了すること
(6)    「コンテンツ」：本サービスにおいて会員が投稿するニュース、ブログ、コメント、記事または読み物等の情報コンテンツ
(7)    「会員サービス」：本サービスのうち、会員に対してのみ提供される第8条に定めるサービス
(8)    「ALISトークン」：本サービスにおいて当社が会員に対して発行する仮想通貨「ALIS」
(9)    「ウォレット」：本サービスにおいて会員がALISトークンを管理するための管理ツール

## 第2条（本サービスの概要）

1. 利用者は、本サービスを通じて当社が提供するコンテンツの情報収集・閲覧サービス等を利用することができます。

2. 当社では、利用者によりよい機能やサービスを提供することができるよう、日々更新を続けています。その目的を達成するために本サービスは、事前の通知等を経ることなく、変更され、機能追加され、本サービスまたはその機能の提供が中止されることがあり、また本サービスの利用に新たな制約が課されることがあります。利用者はそれをあらかじめ承諾した上で本サービスを利用するものとします。

## 第3条(本サービスの利用条件)

1. 当社は、当社の定めにより、本サービスの機能や利用範囲等を会員の年齢や利用環境等に応じて設定するものとします。利用者は、本サービスを利用する際には、年齢や利用環境、各機能やサービス等について、当社の定める条件に応じて、当社の定める範囲内で、本サービスを利用するものとします。
2. 会員は、本サービスを利用する上で、会員自身が設定する登録情報に、虚偽の情報を掲載してはならないものとします。本サービスへの投稿やメッセージの内容は、本サービスの健全な運営のため、当社にて会員に確認を行うことができるものとします。
3. 会員は、登録した電子メールアドレスに当社からのお知らせ等が送信される可能性があることに同意した上で、本サービスを利用します。
4. 本サービスを利用する際に発生するパソコン、スマートフォンを含む情報通信機器等によるメール受信、ウェブサイト閲覧その他の通信の際に必要な一切の通信費用は利用者が負担するものとします。

## 第4条（会員登録）
1. 会員登録を希望する者は、本規約の全てに同意した上、本規約および当社が定める方法により会員登録申請をするものとします。
2. 当社は、前項の会員登録申請があった場合、当社が定める必要な審査、手続き等を経て、当該登録を承認するかどうか決定します。なお、当社は、当社が定める審査基準に合致しない場合その他当社が不適当と考える場合には、会員登録希望者へ理由を開示することなく、当該登録を拒否することができるものとします。
3. 当社が会員登録希望者の会員登録申請を承認した場合、当社と会員登録希望者との間で、本規約を契約内容とする会員サービスの利用契約が締結されるものとします。
4. 以下の利用者は会員登録ができないものとします。

(1)    18歳未満の利用者
(2)    LINE、Facebook、Twitter、Yahoo!等の外部サービスまたはSMSによる本人認証ができない利用者
(3)    成年被後見人、被保佐人または被補助人のいずれかであり、法定代理人、後見人､保佐人または補助人の同意等を得ていない利用者
(4)    反社会的勢力等（暴力団、暴力団員、右翼団体、反社会的勢力、その他これに準ずる者を意味します。以下同じ。）である、または資金提供その他を通じて反社会的勢力等の維持、運営若しくは経営に協力若しくは関与する等反社会的勢力等との何らかの交流もしくは関与を行っていると当社が判断した利用者
(5)    その他、当社が登録を適当でないと判断した利用者

5. 会員サービスには、登録情報以外の情報の登録を必要とするサービスが含まれます。会員がそれら個別のサービスを利用するにあたっては、それぞれのサービスごとに定める必要な情報を登録の上、利用するものとします。
6. 会員は本サービスに会員登録するにあたり、以下の各号に定める事項を遵守するものとします。当該事項に違反したことにより会員に損害が発生したとしても当社は一切その責任を負わないものとします。

(1)    虚偽の登録情報を提供したり、当社の許可を得ることなく他人の登録情報を登録することはできません。
(2)    会員登録が当社によって停止された場合、当社の許可なく新たに会員登録することはできません。
(3)    ボット等を使った不正な登録を行うことはできません。
(4)    会員は登録情報内の連絡先情報を、当社からの電子メールを必ず受け取ることができる状態に保つものとします。

7. 利用者は、会員登録手続において外部サービスを利用して本人認証をすることができます。この場合、利用者は、当社が当該外部サービスのデータにアクセスすることについて許諾をしたうえで、登録手続を行うものとします。なお、当社は、このときに取得した外部サービス情報（個人情報）の利用目的およびその他取り扱いに関する事項について、当社が別途定めるプライバシーポリシーに則り取り扱うものとします。

## 第5条（認証情報・登録情報の管理および変更）
1. 会員は自己の責任と費用負担によって、認証情報および登録情報の管理を行うものとし、認証情報および登録情報を第三者に利用させる行為、第三者に対する認証情報の譲渡、承継、質入、その他一切の処分、または認証情報の公開等をしてはならないものとします。また、会員は、登録情報に変更が生じた場合には速やかにその内容を変更するものとします。
2. 会員は、認証情報を共有したり、他人に会員の認証情報を用いた本サービスへのアクセスを許可したり、その他、会員の登録情報のセキュリティを脅かすおそれのある行為を行わないものとします。
3. 会員による認証情報の管理が不十分であったことによる情報の漏洩、第三者の使用、不正アクセス等または本サービス使用上の過誤によって当該会員または第三者に生じた損害の責任は会員が負うものとし、当社は一切の責任を負わないものとします。万一、認証情報が不正に利用されたことにより当社に損害が生じた場合、会員は当該損害を賠償するものとします。
4. 会員は、認証情報を第三者に知られた場合またはその疑いのある場合には、本規約および当社が定める方法により、直ちに当社にその旨連絡すると共に、第三者による認証情報の利用を回避するため可能な限りの措置を取るものとし、当社の指示がある場合にはこれに従うものとします。
5. 会員が第1項の登録情報の変更または前項の連絡等の措置を取らなかったことにより不利益を被った場合であっても、当社は一切の責任を負わないものとします。
6. 会員が第1項の登録情報の変更をしなかった場合で、当社から当該会員に対する連絡がつかないときその他本サービスの提供に支障をきたすおそれがあるときには、当社は当該会員が退会したとみなすことができるものとします。

## 第6条（退会）
1. 会員は、本規約および当社が定める方法により、いつでも会員サービスの利用を終了し、会員サービスから退会することができるものとします。ただし、会員サービスのシステムの都合上、会員による退会手続きが完了してから、その手続きがシステム上反映されるまで当社所定の時間が必要な場合があり、会員はこれを承諾するものとします。
2. 会員は会員サービスから退会した場合、会員サービスのウォレットに保存しているALISトークン、会員サービスにおける会員の信頼度データ、会員サービスを受ける権利、電子メール等による情報の提供を受ける権利等を含め、会員としての一切の権利を失うものとします。
3. 当社は、会員が以下のいずれかの事由に該当する場合、またはそのおそれがあると当社が判断した場合、会員へ事前に通告・催告することなく、かつ会員の承諾を得ずに、当社の裁量により直ちに、当該会員に対して、本サービスの全部または一部の利用停止、退会処分、その他当社が適切と判断する措置をとることができるものとします。

(1)    本規約に違反した場合
(2)    登録情報に虚偽または過誤がある場合
(3)    登録された電子メールアドレスが機能していないと判断される場合
(4)    第三者になりすまして会員登録を行った場合
(5)    第4条第4項または第6項に違反して登録がされていた場合
(6)    第10条に定める禁止事項を行った場合
(7)    会員が死亡した場合
(8)    他の利用者または会員からの不満・不評・クレームが多く、本サービスにふさわしくないと当社が判断した場合
(9)    当社が本サービスの運営に支障が生じると判断した場合
(10) その他、当社が会員として不適切と判断した場合

4. 前項の場合において、当社が何らかの損害を被った場合、会員は当社に対して当該損害を賠償するものとします。
5. 当社は会員に対して、第3項に定める措置の理由を開示する義務を負わないものとします。
6. 本条の規定により会員が退会したことまたは会員としての権利を失ったことにより会員が何らかの損害を被った場合といえども、当社はその損害について一切の責任を負いません。

## 第7条（本サービスにおけるコンテンツの利用）
1. 利用者は、コンテンツを個人的な利用のみを目的として閲覧するものとし、商業目的等で不特定多数にコンテンツを閲覧させることや、次項に定めを除いてコンテンツを譲渡、複製、貸与、公衆送信等すること、またはこれらの行為を第三者に行わせることはできません。ただし、当該利用者が本サービスの会員として、自ら作成したコンテンツまたは会員自身がその権利を保有するコンテンツであって、その利用にあたって、第三者の権利を害することのない場合を除きます。
2. 本サービスは、会員自身がニュース、ブログ、雑誌、コメント等のコンテンツを投稿、表示し、本サービスの他の利用者および本サービス以外のソーシャルネットワーキングサービスへシェアする機会を提供しています。利用者は、会員が投稿、表示、シェアするコンテンツはすべて以下の条件に従うことについて承諾するものとします。
(1)    コンテンツには多数の個人や組織が発信する情報、見解、意見、および提言が含まれていること。当社は、特定の会員の提言や意見についてそれを支持することはなく、また、コンテンツの定期的な審査、編集は行いません。利用者は、コンテンツを自らの判断と責任で閲覧、利用することに同意します。
(2)    会員は、自身が本サービスに投稿したコンテンツにつき、第三者の権利を侵害せず、また法令等にも違反しないようにすることを保証します。これらの権利または法令等には、知的財産権やプライバシー権を含みますが、これらに限定されません。
(3)    当社は、利用者の皆様に快適にご利用頂くため、本規約に違反する場合または著しく本サービスの方針と関連がない場合には、当社の判断により本サービス上の記事ページやコンテンツを削除することがあります。
(4)    コンテンツについて、本規約に違反しており、かつ権利侵害・誹謗中傷・いやがらせ等を受けた本人からの通報があった場合、当社は、原則として事前通告なく削除いたします。

## 第8条（会員サービス）
1. 当社は、会員サービスとして会員に対して以下のサービスを提供し、会員は以下の行為を本サービスにおいて実施することができるものとします。
(1)    本サービスへのコンテンツの投稿
(2)    他の会員が投稿したコンテンツへ「いいね」をすることによるコンテンツの評価
(3)    前各号に定める行為を行った会員に対して、当社の定めに従って当社が付与するALISトークンを受け取る行為
(4)    第8条の2に定めるウォレットにおける付与されたALISトークンの管理およびALISトークンの入出金
(5)    その他当社の提供する機能・サービスを受ける行為
2. 当社が会員に対して付与するALISトークンの利用については、当社が別途定める「[ALISトークン利用ガイドライン](/token-use-guideline)」に従うものとします。
3. 当社は、会員サービスの形態として、パソコン、スマートフォンを含む情報通信機器等を通じて閲覧可能なウェブサイト、電子メール、その他の手段を通じて随時サービスを提供することができるものとします。
4. 当社は、会員に対し、サーバー障害やサービス更新等が発生した場合の情報を電子メールの送信またはウェブサイトに掲示する方法により通知することができるものとします。
5. 当社は会員に対して、本条に定めるサービス以外のサービスを、会員サービスとして随時追加して実施することができるものとします。
6. 当社は、理由の如何を問わず、会員に事前の通知・催告をすることなく、会員サービスに関して、内容の全部または一部の変更、提供頻度の変更、休止、廃止をすることができるものとします。ただし、会員サービスの全てを廃止する場合には、当社が適当と判断する方法で、会員に対し、事前にその旨を通知または本サービス上で告知するものとします。
7. 当社は、コンテンツを含む会員サービス上のあらゆる情報を、運営上の必要な範囲内において閲覧することができるものとし、当該情報が本規約に抵触すると判断した場合には、会員への事前通知なく、当該情報の全部または一部を非公開としまたは削除することができるものとします。

## 第8条の2（ALISトークンの管理および入出金）
1. 本サービスにおいて、会員は当社の指定するウォレットにおいて自己のALISトークンを管理するものとします。
2. 会員は、当社の定める方法により、当社の指定するウォレットのアドレスへのALISトークンの入金（以下、本条において「ALISトークンの入金」といいます。）または会員の指定する外部ウォレットのアドレスへのALISトークンの出金（以下、本条において「ALISトークンの出金」といい、ALISトークンの入金と併せて「ALISトークンの入出金」といいます。）を行うことができるものとします。
3. ALISトークンの入出金は、会員が当該入出金手続を行った時点ではなく、当社にその手続の通知が到達した時点をもって行われたものとします。
4. 会員は、ALISトークンを出金する場合、当社の定める手数料を支払うものとします。また、ALISトークンの入出金の際に、会員は第三者に手数料を支払う場合があります。
5. 会員は、ALISトークンの入出金を行う場合、当社が別途定める方法に従って、自己の責任において実施するものとします。会員は、自己の責任において、ALISトークンの入出金を行う外部ウォレットのアドレスを指定することとし、当社は、会員が提供した当該外部ウォレットのアドレスにかかる情報の正確性および有効性について責任を負いません。また、当社は、会員の指図に従ってALISトークンの入出金を行った場合、当該入出金の結果につき一切責任を負いません。
6. ALISトークンの入出金に関し、当社は、以下の各号に定める場合において、ALISトークンを含むその他の仮想通貨または法定通貨の喪失等、会員に何らかの損害が発生した場合といえども、当該損害について一切責任を負わず、返還または補償する義務を負いません。

(1) 当社の指定するアドレスと異なるアドレスに会員がALISトークンを送付した場合
(2) ALISトークンの入出金における会員のアドレスの指定ミス等、当社の責任に基づかない原因により当該入出金の不具合が発生した場合
(3) 当社の指定する方法によらないMETAMASK等の仮想通貨ウォレットの設定によりALISトークンの入出金の不具合が発生した場合
(4) 当社が取扱いを行っていない法定通貨、仮想通貨、トークンその他いかなる形態のものを当社の指定するウォレットのアドレスに送付した場合
(5) その他当社の指定する方法以外の方法によりALISトークンの入出金を行った場合

7. 前各項に従って当社が会員の指定するアドレスにALISトークンを送付した場合であっても、ブロックチェーンで当該送付に係る送付がキャンセルされた場合、当社は、当該送付を取り消すことができるものとします。

## 第9条（知的財産権等）
1. 本サービスを構成する文章、画像、動画、プログラムその他一切の情報について発生している著作権その他の知的財産権、肖像権およびパブリシティ権その他の人格権ならびに所有権その他の財産権は、利用者が自ら作成したものに関する権利を除き、当社または当該権利を有する第三者に帰属します。
2. コンテンツに関わる著作権、商標権その他の一切の知的財産権およびその他の財産権は、すべてコンテンツを投稿した利用者に帰属します。また、コンテンツに対してコメント等を投稿した場合、そのコメント等にかかる権利はそのコメント等を行った利用者に帰属します。ただし、当該コンテンツまたはコメント等について第三者がその権利を保有しているものについてはこの限りではなく、利用者は当該コンテンツを本サービスに投稿または表示することについて当該第三者からの許諾を得たうえでコンテンツの投稿を行うものとします。
3. 当社は、利用者が本サービスにおいて投稿、アップロードまたは保存した全ての情報（文字情報、画像情報等を含みますがこれらに限られません）について、これらを保存・蓄積した上、本サービスの円滑な運営、改善または利用者の利便性向上を目的として、利用する可能性があります。ただし、当社は、当社または本サービスの宣伝告知等（第三者のメディアへの掲載を通じた紹介記事・コンテンツ等も含まれます。）を目的として、第三者のサイト等の外部サイトに利用者のコンテンツを掲載・転載する場合（利用者の本サービスの利便性向上のために外部サイトに利用者のコンテンツを掲載・転載する場合を除きます。）には、あらかじめ当該利用者の許諾を得たうえで当該掲載を行うものとします。
4. 利用者は、自己の著作物その他のコンテンツに関して、第三者の権利侵害等の問題が発生した場合、自己の費用と責任においてかかる問題を解決するとともに、当社に何等の迷惑または損害を与えないものとします。

## 第10条（禁止事項）
1. 会員または利用者は、以下の各号に定める行為（本サービスに投稿するコンテンツの内容・表現を含みます）またはそのおそれのある行為を行わず、または第三者にそれらを行わせる行為を行ってはならないものとします。

(1)    コンテンツを著作権法で認められた私的利用の範囲を超えて、複製、出版、公表、譲渡、公衆送信、改変その他の態様で利用する行為。
(2)    第三者の著作物を無断で転載・利用する等、第三者の商標権、著作権、著作者人格権等の知的財産権、肖像権およびパブリシティ権等の権利を侵害する行為
(3)    本人の承諾なく、個人情報を公開する行為（ただし、一般に公開されている著名人等の情報は除きます）。
(4)    第三者の財産、プライバシー等個人の権利を侵害する行為。
(5)	当社の承諾なく、または当社の認める範囲を超えて本サービス中のページ、フォーム、レイアウト、デザインもしくは資料、当社および本サービスの名前、当社の商標、ロゴまたはコンテンツを使用、表示する行為。
(6)	本サービスのコンテンツまたは情報を利用する等して、第三者へ本サービスと同一もしくは類似のサービスを自ら提供し、または第三者へサービスや物品等を提供する等の商用目的で利用する行為。
(7)    当社の通信設備、コンピューター、その他の機器およびソフトウェアに不正にアクセスし、または、その利用若しくは運用に支障を与える行為、コンピュータウィルスその他の有害なコンピュータープログラムを含む情報を送信する行為、または当社の管理するシステム、サーバー、ネットワークその他の機能を破壊もしくは妨害し、もしくは不必要に過度の負担をかける行為。
(8)	本サービスに関連するまたは当社が管理するシステム、サーバー、ネットワークその他のエラー、バグ、セキュリティーホール、その他瑕疵を利用する行為。
(9)    他の会員の認証情報を求め、他人のアカウントにアクセスする行為。
(10) 当社のソースコードの改変や派生物の作成、デコンパイル、その他の操作行為等、本サービスに関し利用しうる情報を改ざんする行為。
(11) 自動化された手段（情報収集ボット、ロボット、スパイダー、スクレーパー等）を使用して、本サービスに会員登録したり、アクセス・スクレイピングする行為およびソフトウェア・ツールを利用するか否かにかかわらず、複数の会員登録をしたり、同一または類似のコンテンツを複数回にわたり投稿する行為。また、それによりなされた会員登録を利用して、コンテンツを投稿し、他のウェブサイト、他のアカウント、他の投稿記事等に対して（リンクを貼る等）誘導する行為。
(12) 不正にALISトークンを取得する目的でコンテンツを大量に投稿する行為または無作為にコンテンツに対して「いいね」を行う行為。
(13) 本サービスで不正な商用メッセージ（迷惑メール等）を投稿する行為。
(14) 本サービスで、ピラミッド商法等、非合法なマルチ商法等を実施する行為。
(15) 本サービスの一部の利用権を当社が定めた以外の方法で譲渡する行為または本サービスの全部もしくは一部の利用権をもって、現金その他の財物、財産上の利益との交換取引をすること、もしくは交換取引をすることの宣伝・告知・勧誘する行為。
(16) 本規約に違反する行為。
(17) 法令または業界団体の定める内部規則に違反する行為。
(18) 犯罪その他の法令違反行為を推奨、肯定、もしくは助長する等、社会的に有害である行為。
(19) 風説や事実と異なることを流布し、偽計または威力等を用いて当社の信用を毀損する行為または恐喝行為
(20) 公職選挙法に抵触する行為。
(21) 本サービスで、特定の宗教団体や宗教活動へ勧誘する行為。
(22) 殺害・虐待・自殺・自殺行為を肯定・勧誘あるいは助長する行為（殺害・自殺の方法等を含む）。
(23) 人種、民族、性別、信条、社会的身分、居住地、身体的特徴、病歴、教育、財産等による差別につながる行為。
(24) 脅迫的、またはわいせつ的なコンテンツや、暴力を誘発するようなコンテンツ、アダルトコンテンツ、ヌード、露骨な、あるいは根拠のない暴力の描写が含まれるコンテンツを投稿する行為、またはこれらのサイト等へのリンクをする行為。
(25) 出会いを希望もしくは誘導することを目的とする行為または異性もしくは同性との交際または性交渉を目的として本サービスを利用する行為。
(26) 他の利用者に対するいじめ、脅迫、嫌がらせに当たる行為。
(27) 他の会員や利用者、当社、その他第三者について、誹謗中傷もしくは侮辱する、または名誉や信用を傷つける行為。
(28) 非合法な行為、誤解を招く行為、悪質な行為、差別的な行為、その他公序良俗に反する行為。
(29) 社会通念上、不適切と解釈される行為または健全な社会通念に反し、品性を損なうような行為等、一般的に他の会員や利用者が不快に感じる行為。
(30) 上記各号のほか、法令に違反する行為、法令または本規約の違反を助長または推奨する行為、本サービスの運営を妨害する行為、当社の信用を毀損し、若しくは当社の財産を侵害する行為、当社に不利益を与える行為、その他当社が本サービスの利用目的から鑑みて不適切と判断する行為。

2. 会員または利用者が、前項各号に違反したと当社が判断した場合には、送信等をした内容の削除、本サービスの全部または一部の利用停止、退会処分、その他当社が適切と判断する措置をとることができるものとします。これにより会員に損害が発生したとしても当社は一切その責任を負わないものとします。
3. 会員または利用者が第1項各号に定める禁止事項のいずれかに違反して不正にＡＬＩＳトークンを取得した場合、当社はその不正に取得したＡＬＩＳトークンをはく奪することができるものとします。
4. 会員または利用者が第1項各号に定める禁止事項のいずれかに違反した場合、当社は、当該会員または利用者に対し、その行為により当社が被った一切の損害（合理的な弁護士費用を含みます）の賠償を請求できるものとします。

## 第11条（本サービスの停止・中止・終了）
1. 当社は、以下各号の事由に該当する場合、本サービスの全部または一部を停止・中止・終了することができるものとします。

(1)    当社が、定期的または緊急に、本サービス提供のためのコンピュータシステムの保守・点検を行う場合
(2)    火災・停電、天災地変等の非常事態により本サービスの運営が不能となった場合
(3)    戦争、内乱、暴動、騒擾、労働争議等により、本サービスの運営が不能となった場合
(4)	コンピューター、通信回線等が事故により停止した場合
(5)    本サービス提供のためのコンピュータシステムの不良および第三者からの不正アクセス、コンピュータウィルスの感染等により本サービスを提供できない場合
(6)    本サービスまたはウォレットへのハッキングその他の方法により、当社または会員の資産の盗難等が起こった場合
(7)    法律、法令、政策等に基づく変更・措置または法定通貨または仮想通貨事情の急変、社会情勢の変化等により本サービスが提供できない場合
(8)	アカウントの不正利用等の調査を行う場合
(9)    法令、業界団体の内部規則、当社規則等に基づき調査を行うことが必要と当社が判断する場合
(10) 利用者の保有する仮想通貨が犯罪収益に関するものまたはその疑いがあると当社が判断する場合
(11) 当社が利用者に対し、事前に電子メールその他の手段により、合理的な範囲で周知した場合
(12) その他、当社が止むを得ないと判断した場合

2. 当社は、前項により本サービスの運用を停止する場合、合理的な範囲で、事前に電子メールその他の手段により、利用者に対し、その旨を通知するものとします。ただし、緊急の場合は、この限りではありません。
3. 当社は利用者に対し事前に通知しまたは利用者から承諾を得ることなく、いつでも任意に、本サービスの内容または名称を変更することができるものとします。

## 第12条（本サービスの提供形態）
当社は、当社が適切と判断する方法にて本サービスを分類し、または順位をつけて掲載または提供することができるものとします。また、当社は、利用者に対し、当該分類または順位に応じて、利用者に種別を設けて、それぞれの利用者ごとに異なるサービス形態で、随時提供することができるものとします。

## 第13条（免責）
1. 当社は、本サービス内に含まれる一切のコンテンツ等の情報（コンテンツにおける仮想通貨の価値、機能、安定性、使用先および用途等を含みます。）について、その合法性、正確性、適切性、妥当性、道徳性、権利許諾の有無を保証せず、いかなる責任（瑕疵担保責任を含みます。）も負うものではありません。また、当社は、仮想通貨自体の価値、安定性および適法性について、一切保証するものではありません。利用者は自己の責任において本サービスを利用するものとし、本サービスのコンテンツに従い何らかの取引や行動を行った結果生じた損害、または利用者による仮想通貨の性質、メカニズムおよびマーケット運営等の理解不足から発生するいかなる損害について、当社はその責任を負わないものとします。さらに、利用者が当社から直接または間接に本サービスまたは他の利用者に関する情報を得た場合であっても、当社は利用者に対し本規約において規定されている内容を超えて如何なる保証も行うものではありません。
2. 当社は、本サービスにおいて、利用者相互間および利用者と第三者との間で生じた一切の連絡、トラブル、紛争等（違法または公序良俗に反する行為の提案、名誉毀損、侮辱、プライバシー侵害、脅迫、誹謗中傷、いやがらせ等）に関して、利用者の責任において処理および解決するものとし、当社は当社に故意または重過失がある場合を除き、一切責任を負わないものとします。
3. 当社は、本サービスにおいて配信される広告情報の内容が、利用者もしくは第三者の権利を侵害し、または権利の侵害に起因して紛争が生じた場合であっても、当社に故意または重過失がある場合を除き、その侵害および紛争に対して責任を負わないものとします。
4. 利用者は、本サービスを利用することが、利用者に適用のある法令、業界団体の内部規則等に違反するか否かを自己の責任と費用に基づいて調査するものとし、当社は、利用者による本サービスの利用が、利用者に適用のある法令、業界団体の内部規則等に適合することを何ら保証するものではありません。
5. 当社は、第11条第1項による本サービスの停止・中止・終了および同条第3項による本サービスの変更、第16条第５項による外部サービスの利用の停止・変更・中止・終了、会員の登録情報またはALISトークンの削除、取消もしくは消失または本サービスの利用によるデータの消失ならびに機器の故障もしくは損傷等、本サービスに関連して利用者または会員に発生した一切の損害（情報等の消失に起因する損害を含みますが、これに限られません）について、責任を負わないものとします。
6. 当社は、本サービスにおいて、会員の本サービスの利用に応じてALISトークンを付与するサービスを行うものであって、会員のALISトークンに関する取引に関する何らかの義務を負うものではありません。したがって、ALISトークン自体の価格の変動またはALISトークンの取引より、会員に損害が発生した場合でも、当社は、会員に対して、損害を賠償する責任を一切負わないものとします。また、会員の入力誤りその他のいかなる行為、会員、当社または第三者の通信・システム機器等の故障、障害もしくは稼働状況、天災地変またはサイバー攻撃その他のいかなる原因により、当社がサービスの全部または一部を停止または制限する、会員のALISトークンのトランザクションが無効となる、意図しない約定結果となるもしくは約定しない、トランザクションの執行が遅延するまたは意図しないトランザクションが執行される等の事案が発生し、これにより会員または第三者に損害が生じた場合において、当社は一切の責任を負わないこととします。
7. 利用者は、自己の責任において本サービスおよび当社ウェブサイトの使用を行うものとします。当社は、利用者のコンピューター機器および環境に対するウェブサイトおよびサービスの妥当性または互換性を保証せず利用者が使用するパソコン・スマートフォン端末・モバイル端末、回線、ソフトウェア等の環境等またはコンピュータウィルス感染等に起因して生じた一切の損害について、責任を負わないものとします。なお、当社は別途定める方法により、利用者に対して、当該環境等について告知をすることがあります。
8. 本サービスまたは当社のウェブサイトから他のウェブサイトへのリンクまたは他のウェブサイトから本サービスまたは当社のウェブサイトへのリンクが提供されている場合でも、当社は、他のウェブサイトおよびそこから得られる情報に関して如何なる理由に基づいても一切の責任を負わないものとします。
9. 本サービスにおいて提供されるコンテンツに関する第三者と利用者との間の一切の取引については、当該第三者と利用者の責任においてなされるものとし、当社は当該取引に関する責任を負わないものとします。
10.   当社は、システムの異常等いかなる事由であれ、ALISトークンの付与が、実態と大幅に乖離している等、誤りもしくは異常値である、または不正な方法に基づくものと当社が合理的に判断する場合には、当該付与を無効とすることができます。これにより直接または間接に発生した損失等について当社は賠償等、一切の責任を負いません。
11.   当社は、仮想通貨に対する法律、政令、法令、規則、命令、通達、条例、ガイドラインその他の規制もしくは関連した消費税を含む税制の将来の変更により、利用者に損害が発生した場合であっても、賠償する責任を一切負わないものとします。また、これらの変更が過去に遡及した場合で、これにより利用者に損害が発生した場合であっても、過去に遡って賠償する責任を一切負わないものとします。
12.   当社は、前各項に掲げるほか、本サービスの利用に起因して利用者に発生した一切の損害について、責任を負わないものとします。ただし、本項または前各項において、個人である利用者の損害が当社または当社の役職員の過失によって生じたときは、当社の賠償責任は、損害発生時に当該利用者のウォレット内に存在したALISトークンの時価相当額またはALISトークンの数量のうち少ない方を上限とします。また、当社または当社の役職員の故意または重過失によって生じたときは、前各項および本項の規定は適用されないものとします。

## 第14条（権利義務の譲渡禁止）
利用者は、当社の書面による事前承諾なしに、本規約に基づく一切の権利または義務について、第三者への譲渡、承継、質入、その他一切の処分をしてはならないものとします。

## 第15条（当社と利用者間の連絡・通知）
1. 当社は、利用者に対して何らかの連絡または告知を行う場合、当社は、本サービス上での掲示または会員が登録した電子メールアドレスへの連絡等、当社が適切と判断する方法にて連絡、通知または告知を行うものとします。これらの方法をとる限りにおいて当社の連絡、通知または告知は適切に行われたものとします。
2. 利用者が当社に対して何らかの連絡を取る場合は、当社が別途定める連絡窓口より連絡を行うものとし、Twitter、GitHub、Discord、Reddit、その他ソーシャルネットワーキングサービス等の手段により当社に対して連絡を行った場合といえども当該連絡は適切に行われなかったものとみなされることがあります。

## 第16条（外部サービスの利用）
1. 利用者は、本サービスにおいて、外部サービスによる本人認証・利用を含む全ての外部サービスの利用（利用者が作成した書き込み内容および行為の外部サービスへのリンクまたは投稿を含みます。）については、利用者は、外部サービス運営会社が規定する各規約の定めに従うものとします。
2. 利用者は、外部サービスにおけるアカウントの登録・管理等を自己の責任において行うものとします。
3. 利用者の管理不十分、使用上の過誤、第三者の使用等による損害の責任は利用者が負うものとし、当社は利用者の外部サービスにおけるアカウントに関する一切の責任を負いません。
4. 外部サービスを利用する場合、利用者は、自己の責任において当該サービスを利用するものとし、当社は、当該サービスを利用したことにより生じた損害、当該サービスの運営者・利用者等との間に生じたトラブルその他の当該サービスに関連する一切の事項について何らの責任も負わないものとします。
5. 当社は、利用者への事前の通知なく、外部サービスの仕様変更その他の理由により、本サービスにおける外部サービスの利用を停止、変更、中止または終了することができるものとします。

## 第17条（本規約の改定）
1. 当社は、随時本規約を改定することができるものとします。
2. 当社は、本規約を改定しようとする場合、電子メールまたは本サービスに関するウェブサイト等を使い随時、会員または利用者に告知したうえで、当社の定めに従って本規約の改定を行うものとします。
3. 前項に基づき、本規約の改定を告知した日から当社が定める期間内に会員が退会しない場合、または利用者が本サービスの利用を継続する場合、当該会員または利用者は本規約の改定に同意したものとみなされ、当該会員または利用者と当社との間で改定後の規約の効力が発生するものとします。
4. 会員または利用者は、前項に定める効力発生の時点以降、当該内容の不知または不承諾を申し立てることはできないものとします。

## 第18条（協議・管轄裁判所）
1. 当社、本サービスに関連して会員、当社、第三者との間で疑義、問題が生じた場合、都度誠意をもって協議し、解決を図るものとします。
2. 本規約に関する一切の訴訟その他の紛争については、東京簡易裁判所または東京地方裁判所を第１審の専属的合意管轄裁判所とするものとします。

## 第19条（準拠法）
本規約は、日本法に準拠し、日本法に従って解釈されるものとします。

 2018年  4月 17日 制定
 2018年  6月 26日 改定
 2018年 10月 16日 改定
 2019年  4月 29日 改定
`
    }
  }
}
</script>

<style lang="scss" scoped>
.terms-of-service-container {
  display: grid;
  grid-template-rows: 100px 50px 1fr 75px;
  grid-template-columns: 1fr 640px 1fr;
  /* prettier-ignore */
  grid-template-areas:
    'app-header       app-header       app-header      '
    '...              ...              ...             '
    '...              article          ...             '
    'app-footer       app-footer       app-footer      ';
  background: white;
}

.area-article {
  display: grid;
  grid-area: article;
  grid-template-rows: auto;
  grid-template-columns: auto;
  grid-gap: 30px;
  /* prettier-ignore */
  grid-template-areas:
    'title  '
    'content';
}

.area-title {
  font-size: 25px;
  grid-area: title;
  letter-spacing: 0.05em;
}

.area-content {
  grid-area: content;
}

@media screen and (max-width: 1080px) {
  .terms-of-service-container {
    grid-template-rows: 100px 50px 1fr 75px;
  }
}

@media screen and (max-width: 820px) {
  .terms-of-service-container {
    grid-template-columns: 80px 1fr 80px;
  }
}

@media screen and (max-width: 550px) {
  .terms-of-service-container {
    grid-template-rows: 70px 0 1fr min-content;
    grid-template-columns: 10px 1fr 10px;
    /* prettier-ignore */
    grid-template-areas:
    'app-header       app-header       app-header      '
    '...              ...              ...             '
    'article          article          article         '
    'app-footer       app-footer       app-footer      ';
  }

  .area-article {
    grid-template-columns: 8px auto 8px;
    grid-gap: 10px;
    /* prettier-ignore */
    grid-template-areas:
      '...            title             ...           '
      '...            content           ...           ';
  }

  .area-content {
    width: 90vw;
  }

  .area-title {
    font-size: 18px;
    grid-area: title;
    letter-spacing: 0.1em;
  }
}
</style>
